export class CguMessages {
  public article1_title = 'cgu.article_1_title';
  public article1 = 'cgu.article_1';
  public article1_1 = 'cgu.article_1_1';
  public article1_2 = 'cgu.article_1_2';
  public article2_title = 'cgu.article_2_title';
  public article2_1 = 'cgu.article_2_1';
  public article2_link = 'cgu.article_2_link';
  public article2_2 = 'cgu.article_2_2';
  public article2_3 = 'cgu.article_2_3';
  public article2_4 = 'cgu.article_2_4';
  public article3_title = 'cgu.article_3_title';
  public article3 = 'cgu.article_3';
  public article4_title = 'cgu.article_4_title';
  public article4 = 'cgu.article_4';
  public article4_1 = 'cgu.article_4_1';
  public article5_title = 'cgu.article_5_title';
  public article5 = 'cgu.article_5';
  public article5_1 = 'cgu.article_5_1';
  public article5_2 = 'cgu.article_5_2';
  public article5_3 = 'cgu.article_5_3';
  public article6_title = 'cgu.article_6_title';
  public article6 = 'cgu.article_6';
  public article6_1 = 'cgu.article_6_1';
  public article6_2 = 'cgu.article_6_2';
  public article6_3 = 'cgu.article_6_3';
  public article6_4 = 'cgu.article_6_4';
  public article6_5 = 'cgu.article_6_5';
  public article6_list = 'cgu.article_6_list';
  public article6_list_1 = 'cgu.article_6_list_1';
  public article6_list_2 = 'cgu.article_6_list_2';
  public article6_list_3 = 'cgu.article_6_list_3';
  public article6_list_4 = 'cgu.article_6_list_4';
  public article7_title = 'cgu.article_7_title';
  public article7 = 'cgu.article_7';
  public article7_1 = 'cgu.article_7_1';
  public article7_2 = 'cgu.article_7_2';
  public article7_3 = 'cgu.article_7_3';
  public article7_4 = 'cgu.article_7_4';
  public article8_title = 'cgu.article_8_title';
  public article8 = 'cgu.article_8';
  public article8_1 = 'cgu.article_8_1';
  public article8_list = 'cgu.article_8_list';
  public article8_list_1 = 'cgu.article_8_list_1';
  public article8_list_2 = 'cgu.article_8_list_2';
  public article8_list_3 = 'cgu.article_8_list_3';
  public article8_2 = 'cgu.article_8_2';
  public article8_title_1 = 'cgu.article_8_title_1';
  public article8_3 = 'cgu.article_8_3';
  public article8_list_4 = 'cgu.article_8_list_4';
  public article8_list_5 = 'cgu.article_8_list_5';
  public article8_list_6 = 'cgu.article_8_list_6';
  public article8_list_7 = 'cgu.article_8_list_7';
  public article8_title_2 = 'cgu.article_8_title_2';
  public article8_4 = 'cgu.article_8_4';
  public article8_title_3 = 'cgu.article_8_title_3';
  public article8_5 = 'cgu.article_8_5';
  public article8_6 = 'cgu.article_8_6';
  public article8_title_4 = 'cgu.article_8_title_4';
  public article8_7 = 'cgu.article_8_7';
  public article8_title_5 = 'cgu.article_8_title_5';
  public article8_8 = 'cgu.article_8_8';
  public article8_9 = 'cgu.article_8_9';
  public article8_10 = 'cgu.article_8_10';
  public article8_title_6 = 'cgu.article_8_title_6';
  public article8_11 = 'cgu.article_8_11';
  public article8_12 = 'cgu.article_8_12';
  public article8_title_7 = 'cgu.article_8_title_7';
  public article8_13 = 'cgu.article_8_13';
  public article8_title_8 = 'cgu.article_8_title_8';
  public article8_14 = 'cgu.article_8_14';
  public article8_15 = 'cgu.article_8_15';
  public article8_16 = 'cgu.article_8_16';
  public article8_link = 'cgu.article_8_link';


  constructor() {
  }
}
